var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.menuItems),function(x){return _c('div',{staticClass:"menu-section"},[_c('div',{staticClass:"section-name"},[_vm._v(_vm._s(x.name))]),_vm._l((x.items),function(i){return _c('router-link',{key:i.to,staticClass:"side-menu-item",attrs:{"to":i.to}},[_c('i',{staticClass:"mat-icon"},[_vm._v(_vm._s(i.icon))]),_c('span',[_vm._v(_vm._s(i.name))])])})],2)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1d74896","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/StaffNavigation.vue
// module id = 706
// module chunks = 0